module.exports = __webpack_public_path__ + "920436cdfc29454cd144a307ce49ae10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2018/midyear/icons/elevation.png
// module id = 1882
// module chunks = 1